import { render, staticRenderFns } from "./FunctionAccessNew.vue?vue&type=template&id=5c317259"
import script from "./FunctionAccessNew.vue?vue&type=script&lang=js"
export * from "./FunctionAccessNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports